var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.payload, function(value, property) {
        return _c("div", [
          _c("label", [_vm._v(_vm._s(property))]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.payload[property],
                expression: "payload[property]"
              }
            ],
            domProps: { value: _vm.payload[property] },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.payload, property, $event.target.value)
              }
            }
          })
        ])
      }),
      _vm._v(" "),
      _c("div", [_c("button", { on: { click: _vm.save } }, [_vm._v("Save")])]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("hr")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cb66357c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb66357c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-core/address/Form.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cb66357c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/modulatte-core/address/Form.vue
// module chunks = 0